import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { CircularProgress, Dialog, DialogContent, Divider } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { signIn } from 'store/auth'
import { getConsoleHome } from 'routes'
import { useHistory } from 'react-router-dom'
import { Form, Formik } from 'formik'
import CustomTextField from 'components/Form/CustomTextField'
import { Box } from '@mui/material'
import { userLoginSchema } from 'schemas/admins'
import Recaptcha from 'components/Recaptcha'
import useRecaptcha from 'hooks/useCustomRecaptcha'
import { verifyGoogleRecaptcha } from 'store/subject'
import { toast } from 'react-toastify'

const Landing = () => {
  const { isRecaptchaValid, recaptchaCode, handleChangeRecaptcha, handleExpired } = useRecaptcha()
  const [remountRecaptcha, setRemountRecaptcha] = useState(false)

  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [inProgress, setProgress] = useState(false)
  const { user } = useSelector((state) => state.auth)

  const initialValues = {
    email: '',
    password: ''
  }

  useEffect(() => {
    if (user?.id) {
      history.push(getConsoleHome(user))
    }
  }, [user])

  const onSubmit = async (values) => {
    try {
      setProgress(true)
      const isRecaptchaVerified = await dispatch(verifyGoogleRecaptcha(recaptchaCode))
      if (isRecaptchaVerified) {
        const user = await dispatch(signIn(values.email, values.password))
        if (user) {
          history.push(getConsoleHome(user))
          return
        }
        setRemountRecaptcha(true)
      } else {
        toast.error('reCAPTCHA failed')
      }
    } catch (e) {
      console.error(e)
    } finally {
      setProgress(false)
    }
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={true}
        PaperProps={{
          style: {
            borderRadius: 25
          }
        }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Typography style={{ fontWeight: 'bold', marginTop: 17, marginBottom: 17 }} variant="h6">
            MeetSymple
          </Typography>
        </div>
        <Divider />
        <DialogContent className={classes.content}>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={userLoginSchema}
            onSubmit={onSubmit}>
            <Form className={classes.form}>
              <Box>
                <Typography variant="body2" style={{ marginBottom: 5, fontWeight: 'bold' }}>
                  Email
                </Typography>
                <CustomTextField placeholder="example@email.com" name="email" type="email" />
              </Box>
              <Box>
                <Typography variant="body2" style={{ marginBottom: 5, fontWeight: 'bold' }}>
                  Password
                </Typography>
                <CustomTextField placeholder="**********" name="password" type="password" />
              </Box>
              <Box>
                <Recaptcha
                  handleChange={handleChangeRecaptcha}
                  onExpired={handleExpired}
                  remount={remountRecaptcha}
                />
              </Box>
              <Button
                fullWidth
                className={classes.loginBtn}
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                startIcon={inProgress && <CircularProgress size={17} />}
                disabled={inProgress || !isRecaptchaValid}>
                Login
              </Button>
            </Form>
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default Landing

const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '300px'
  },
  content: {
    marginTop: '40px',
    padding: '20px 40px'
  },
  loginBtn: {
    fontWeight: 'bold',
    textTransform: 'none',
    width: '100%',
    height: 55,
    marginBottom: '25px'
  },
  root: {
    flexGrow: 1,
    marginBottom: 20
  }
})
